/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Stat_ImportedInputs */

const en_ui_studio_stat_imported = /** @type {(inputs: Ui_Studio_Stat_ImportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imported`)
};

const de_ui_studio_stat_imported = /** @type {(inputs: Ui_Studio_Stat_ImportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importiert`)
};

/**
* | output |
* | --- |
* | "Imported" |
*
* @param {Ui_Studio_Stat_ImportedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_stat_imported = /** @type {((inputs?: Ui_Studio_Stat_ImportedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Stat_ImportedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_stat_imported(inputs)
	return de_ui_studio_stat_imported(inputs)
});